import { ReduxHelper } from "helpers"
import { IAddGalleryRequest} from "models/RequestModels"
import { IGallery } from "models"
export const prefix = "GALLERY";

const addGallery = ReduxHelper.generateActions<IAddGalleryRequest, IGallery>(`${prefix}/ADD_GALLERY`);

export {
    addGallery
}